import { useQuery } from '@tanstack/react-query';
import { spectralWorkspaceStore } from '../../research/store/spectralWorkspaceStore';

export const sessionGroupResearchUsagesQueryKey = (groupId?: string) =>
  ['session-group-research-usages', groupId] as const;

export const useSessionGroupResearchUsages = (groupId?: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: sessionGroupResearchUsagesQueryKey(groupId),
    queryFn: () =>
      spectralWorkspaceStore.listAnalysesUsingSessionGroup(groupId!),
    enabled: Boolean(groupId),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });

  return {
    usages: data ?? [],
    isLoading,
    error,
  };
};
